let modals;

let modalManager;

const close = () => {
  if (!modalManager.activeModal) {
    return Promise.resolve();
  }

  const unsetActiveModal = () => {
    modalManager.activeModal = null;
  };

  return modalManager.activeModal.close()
    .then(unsetActiveModal);
};

const makeModal = (name) => {
  const factory = modals[name];

  if (!factory) {
    throw new Error(`Modal factory doesn't exist: ${name}`);
  }

  return factory.make();
};

const open = (name) => {
  const openModal = () => {
    modalManager.activeModal = makeModal(name);

    return modalManager.activeModal.open();
  };

  return modalManager.close()
    .then(openModal);
};

const onClick = (event) => {
  const leftButton = 0;

  if (
    event.button !== leftButton ||
    !event.target.hasAttribute('data-modal')
  ) {
    return;
  }

  // Prevent page navigation on hyperlinks
  if (event.target.tagName === 'A') {
    event.preventDefault();
  }

  const modalName = event.target.getAttribute('data-modal');

  modalManager.open(modalName);
};

const init = (modalObjects) => {
  modals = modalObjects;
  document.addEventListener('click', onClick);
};

const destroy = () => {
  document.removeEventListener('click', onClick);

  if (modalManager.activeModal) {
    modalManager.activeModal.destroy();
    modalManager.activeModal = null;
  }
};

modalManager = {
  activeModal: null,
  close,
  init,
  open,
  destroy,
};

export default modalManager;
modalManager;
